/**
 *
 * @module telemetryManagerConfiguration
 *
 */

import ServiceConfiguration from './serviceConfiguration';

/**
 *
 * @class TelemetryManagerConfiguration
 * @desc Provides configuration information necessary for managing telemetry.
 *
 */
export default class TelemetryManagerConfiguration extends ServiceConfiguration {}



// WEBPACK FOOTER //
// ./src/services/configuration/telemetryManagerConfiguration.js